import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { PageEvent } from '@angular/material/paginator';
import { MatFormField, MatOption, MatSelect } from '@angular/material/select';
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [
    MatFormField,
    MatSelect,
    MatIcon,
    MatOption,
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltip
],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.css'
})
export class PaginatorComponent implements OnChanges {

  @Input() width: string = '100%';
  @Input() length: number = 0;
  @Input() pageSize: number = 10;
  @Input() pageIndex: number = 0;
  @Input() pageSizeOptions: number[] = [10, 20, 50, 100];

  @Output() pageChange = new EventEmitter<PageEvent>();

  infoLabel: string = '';

  ngOnChanges() {
    this.atualizarLabel();
  }

  atualizarLabel() {
    const start = this.pageIndex * this.pageSize;
    const end = Math.min(start + this.pageSize, this.length);

    this.infoLabel = `${start + 1} – ${end} de ${this.length}`;
  }

  alterarTamanhoPagina(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 0;
    this.emitirEvento();
  }

  navegar(acao: 'first' | 'prev' | 'next' | 'last') {
    switch (acao) {
      case 'first':
        this.pageIndex = 0;
        break;
      case 'prev':
        this.pageIndex = Math.max(0, this.pageIndex - 1);
        break;
      case 'next':
        this.pageIndex = Math.min(Math.ceil(this.length / this.pageSize) - 1, this.pageIndex + 1);
        break;
      case 'last':
        this.pageIndex = Math.ceil(this.length / this.pageSize) - 1;
        break;
    }
    this.emitirEvento();
  }

  emitirEvento() {
    this.pageChange.emit({
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      length: this.length
    });
    this.atualizarLabel();
  }
}
